export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/payer_payment_notifications/store/state.js